import categoryService from "../../../../services/CategoryService"
import Notify from "../../../../elements/Notify"
import Dialog from "../../../../elements/Dialog"

export default {
   name: 'ProductCategoryList',
   data() {
      return {
         filter  : '',
         loading : false,
         columns : [
            {
               name: 'number',
               label: '#',
               align: 'left',
               style: 'width: 50px'
            },
            {
               name: 'category',
               label: 'Categoria de producto',
               align: 'left',
               field: 'name',
            },
            {
               name: 'status',
               label: 'Disponible',
               align: 'center',
               field: 'status',
               style: 'width: 80px'
            },
            {
               name: 'action',
               label: 'Acciones',
               align: 'center',
               style: 'width: 100px'
            },
         ],
         tableData: []
      }
   },
   created() {
      this.$store.dispatch('title', 'Categorias')
      this.loading = true;
      categoryService.getRef().on('value', snapshot => {
         this.replaceTableData(snapshot.val())
         this.loading = false
      })
   },
   mounted() {
   },
   methods: {
      deleteCategory(category) {
         Dialog.confirm('Eliminar', '¿Esta seguro de querer eliminar esta categoria? No se podrá recuperar esta información nuca mas.')
            .then(()=>{
               categoryService.deleteCategory(category.id)
                  .then(() => {
                     Notify.success("Se eliminó correctamente.")
                  })
                  .catch((e) => {
                     Notify.error(e)
                  })
            })
            .catch(() => {
               Notify.info("Gracias por no eliminarme.")
            })
      },
      changeStatus(category) {
         categoryService.updateCategory(category)
            .then(() => {
               Notify.success("Se actualizó el estado de la categoría.")
            })
            .catch((e) => {
               Notify.error(e)
            })
      },
      replaceTableData(data) {
         this.tableData = []
         for (const key in data) {
            if (data.hasOwnProperty(key)) {
               const element = data[key]
               element.status = element.status == '1'
               this.tableData.push(element)
            }
         }
      }
   }
}
